export default __webpack_public_path__ + "40b0ef0b66309c4b517c3a213f0e8ce0.svg";